// fddCalc.js — wrapper around labEngine.coreCutter() (IS 2720 Part 29:1975, core cutter method) with input sanity checks.
import { coreCutter, crossCheck, checkResolution } from '../labEngine';

const CLAUSE = 'IS 2720-29:1975';

// dets = [{ cutterG, cutterSoilG, wetG, dryG, tareG }]
export function computeFDD({ diameterCm, heightCm, volumeCc, passing475Pct, labMddGcc, dets }) {
  const issues = [];
  let bad = false;
  const block = (code, msg, clause = CLAUSE) => { bad = true; issues.push({ level: 'block', code, clause, msg }); };

  if (!(diameterCm > 0)) block('DIM', 'Core cutter diameter must be above 0');
  if (!(heightCm > 0)) block('DIM', 'Core cutter height must be above 0');
  if (!(volumeCc > 0)) block('DIM', 'Core cutter volume must be above 0');
  if (!(labMddGcc > 0)) block('MDD', 'Lab MDD must be above 0');
  if (!(passing475Pct >= 0 && passing475Pct <= 100)) block('PASSING', '% passing 4.75 mm must be between 0 and 100');

  dets.forEach((d, i) => {
    const tag = `Determination ${i + 1}`;
    if (!(d.cutterG > 0)) block('CUTTER', `${tag}: core cutter weight must be above 0`);
    else if (!(d.cutterSoilG > d.cutterG)) block('CUTTER', `${tag}: cutter + wet soil must be more than the empty cutter`);
    if (!(d.tareG > 0)) block('MC', `${tag}: container weight must be above 0`);
    else if (!(d.dryG > d.tareG)) block('MC', `${tag}: container + dry must be more than the container`, 'IS 2720-2:1973');
    else if (!(d.wetG >= d.dryG)) block('MC', `${tag}: container + wet must be at least container + dry`, 'IS 2720-2:1973');
  });
  if (!dets.length) block('DETS', 'Enter at least one determination');
  if (bad) return { result: null, issues };

  // readings must be believable balance readings (cutter balance 1 g, moisture balance 0.01 g)
  dets.forEach((d, i) => {
    const tag = `Determination ${i + 1}`;
    issues.push(checkResolution(`${tag} cutter`, d.cutterG, 1, `${CLAUSE} 3.4`));
    issues.push(checkResolution(`${tag} container + wet`, d.wetG, 0.01, 'IS 2720-2:1973'));
    issues.push(checkResolution(`${tag} container + dry`, d.dryG, 0.01, 'IS 2720-2:1973'));
    issues.push(checkResolution(`${tag} container`, d.tareG, 0.01, 'IS 2720-2:1973'));
  });

  const out = coreCutter({ diameterCm, heightCm, volumeCc, passing475Pct, labMddGcc, dets });
  const rows = out.result.rows;
  const mean = (xs) => xs.reduce((a, b) => a + b, 0) / xs.length;
  const result = {
    ...out.result,
    wetDensityAvg: mean(rows.map((r) => r.bulk)),
    mcAvg: mean(rows.map((r) => r.w)),
    dryAvg: mean(rows.map((r) => r.dry)),
  };
  return {
    result,
    issues: [...issues, ...out.issues, ...crossCheck({ compactionPct: result.compactionPct })].filter(Boolean),
  };
}
